import { Clock3, ImageIcon, ShieldAlert } from "lucide-react";
import { t } from "@/lib/i18n";

export function Pending({ className = "", testId = "pending-placeholder" }) {
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border border-dashed border-[#C9A86A] bg-[#FFFBEB] px-3 py-1 text-xs font-medium text-[#78350F] ${className}`} data-testid={testId}>
      <Clock3 className="h-3.5 w-3.5" aria-hidden="true" />
      {t("preview.pending")}
    </span>
  );
}

export function StockBadge({ className = "" }) {
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full bg-[#FEF3C7]/95 px-2.5 py-1 text-[11px] font-semibold text-[#92400E] shadow-sm backdrop-blur ${className}`} data-testid="stock-image-badge">
      <ImageIcon className="h-3 w-3" aria-hidden="true" />
      {t("preview.stock")}
    </span>
  );
}

export function UnverifiedTag() {
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-[#FEE2E2] px-2 py-0.5 text-[11px] font-semibold text-[#991B1B]" data-testid="unverified-tag">
      <ShieldAlert className="h-3 w-3" aria-hidden="true" />
      {t("preview.unverified")}
    </span>
  );
}

export function StatusLabel({ status }) {
  if (!status) return null;
  return (
    <span className="inline-flex items-center rounded-full border border-forest/25 bg-forest/[0.06] px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider text-forest" data-testid="module-status-label">
      {t(`status.${status}`)}
    </span>
  );
}
